import React from 'react';
import ColorToggleImage from './ColorToggleImage';
import Sparkle from './Sparkle';
import './SparkleImageButton.scss';

export default function SparkleImageButton({ on, src, onClick }: { on: boolean, src: string, onClick: () => void }) {
    return (
        <div
            className="to-scale sparkle-image"
            onClick={() => {
                onClick();
            }}
            style={{
                position: 'relative'
            }} >
            <Sparkle
                overflowPxX={-8}
                overflowPxY={-5}
                maxSize={3}
                minSize={1}
                canvasClassName={'sparkle-canvas'}>
                <ColorToggleImage src={src} startColorized={on} />
            </Sparkle>
        </div>
    )
}